import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-5',
  templateUrl: './5.component.html',
  styleUrls: ['./5.component.scss'],
})
export class VbTablesBootstrap5Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
